import styled from 'styled-components'
import { media, styles } from 'shared/lib'
/**
 * Standard way of laying a single panel onto a page
 *
 * Usage
 * <PageLayout title="Customer Login">
 *   <PanelPageLayout>
 *      <LoginPanel />
 *   </PanelPageLayout>
 * </PageLayout>
 */
const PanelPageLayout = styled.div`
  padding: ${styles.mobilePageLayoutPadding} 0 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${media.large`
    padding-top: 40px;
    padding-bottom: 200px;
  `}
`
export default PanelPageLayout
